import { IconProps, User } from 'grommet-icons';

export const UserIcon: React.FC<IconProps> = (props) => <User size="24px" color="brand" {...props} />;
